/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {refreshSession} from '../api'

export const useMutationRefreshSession = createReactQueryMutationHook('refreshSession', refreshSession)
